import { render, staticRenderFns } from "./ModalPatientCard.vue?vue&type=template&id=3292ddb0&scoped=true&"
import script from "./ModalPatientCard.vue?vue&type=script&lang=js&"
export * from "./ModalPatientCard.vue?vue&type=script&lang=js&"
import style0 from "./ModalPatientCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ModalPatientCard.vue?vue&type=style&index=1&id=3292ddb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3292ddb0",
  null
  
)

export default component.exports